import { render } from "./addMenu.vue?vue&type=template&id=8c7b361c&scoped=true"
import script from "./addMenu.vue?vue&type=script&lang=js"
export * from "./addMenu.vue?vue&type=script&lang=js"

import "./addMenu.vue?vue&type=style&index=0&id=8c7b361c&lang=scss&scoped=true"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7b361c"]])

export default __exports__